import { useState } from 'react';
import { subscribe, emailOk, ukPhone } from '@/lib/klaviyo';
import { SITE } from '@/data';
import { Status } from './forms';
import { Reveal } from './Reveal';

export default function EventSection() {
  const [msg, setMsg] = useState({ kind: 'idle', text: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const trap = form.querySelector('[name=website]');
    if (trap && trap.value) return; // bot trap
    setMsg({ kind: 'idle', text: '' });
    if (!emailOk(form.email.value.trim())) {
      setMsg({ kind: 'err', text: 'Pop in a valid email address.' });
      return;
    }
    const firstName = form.firstName.value.trim();
    if (firstName.length < 2) {
      setMsg({ kind: 'err', text: 'Tell us your first name.' });
      return;
    }
    const ph = ukPhone(form.phone.value);
    if (ph.replace(/\D/g, '').length < 10) {
      setMsg({ kind: 'err', text: 'Pop in a valid mobile number.' });
      return;
    }
    const btn = form.querySelector('[type=submit]');
    const label = btn.textContent;
    btn.disabled = true;
    subscribe(SITE.klaviyo.eventListId, form.email.value.trim(), 'Website: Princess Nyah & Friends ticket alerts', { first_name: firstName, mobile_number: ph })
      .then(() => {
        form.reset();
        setMsg({ kind: 'ok', text: 'Nearly there — check your inbox (and spam) and hit confirm to be first when tickets drop.' });
      })
      .catch(() => setMsg({ kind: 'err', text: "That didn't go through. Please try again in a moment." }))
      .finally(() => {
        btn.disabled = false;
        btn.textContent = label;
      });
  };

  return (
    <section id="event" className="mx-auto max-w-[1280px] scroll-mt-24 px-6 pt-24 md:pt-32" data-testid="event-section">
      <Reveal>
        <div className="relative overflow-hidden rounded-[32px] bg-mauve text-plum">
          <div className="relative grid grid-cols-1 items-center gap-10 p-8 md:p-14 lg:grid-cols-2">
            <div className="flex flex-col items-start gap-4">
              <span className="font-mono text-[12px] font-bold uppercase tracking-[0.25em] text-plum/70">
                It's Funky Baby presents
              </span>
              <h2 className="font-display text-5xl uppercase leading-[0.95] md:text-6xl">
                PRINCESS NYAH <span className="opacity-60">&amp;</span> FRIENDS
              </h2>
              <p className="max-w-[420px] text-lg text-plum/75">
                Sign up here for upcoming FUNKY events. Be first to know when tickets drop!
              </p>
            </div>

            <form
              className="flex flex-col gap-3 lg:border-l-2 lg:border-dashed lg:border-plum/25 lg:pl-10"
              noValidate
              onSubmit={handleSubmit}
              data-testid="event-alert-form"
            >
              <label className="text-sm font-bold text-plum/80" htmlFor="ev-name">
                First name
              </label>
              <input
                id="ev-name"
                name="firstName"
                type="text"
                autoComplete="given-name"
                placeholder="What do we call you?"
                required
                className="w-full rounded-2xl border-0 bg-[#F6EDE4] px-5 py-4 text-base text-plum placeholder:text-plum/50 focus:outline-none focus:ring-2 focus:ring-plum/40"
                aria-label="First name"
                data-testid="event-name-input"
              />
              <label className="text-sm font-bold text-plum/80" htmlFor="ev-email">
                Email
              </label>
              <input
                id="ev-email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="you@email.com"
                required
                className="w-full rounded-2xl border-0 bg-[#F6EDE4] px-5 py-4 text-base text-plum placeholder:text-plum/50 focus:outline-none focus:ring-2 focus:ring-plum/40"
                aria-label="Email for ticket alerts"
                data-testid="event-email-input"
              />
              <label className="text-sm font-bold text-plum/80" htmlFor="ev-phone">
                Mobile
              </label>
              <input
                id="ev-phone"
                name="phone"
                type="tel"
                autoComplete="tel"
                placeholder="07…"
                required
                className="w-full rounded-2xl border-0 bg-[#F6EDE4] px-5 py-4 text-base text-plum placeholder:text-plum/50 focus:outline-none focus:ring-2 focus:ring-plum/40"
                aria-label="Mobile number"
                data-testid="event-phone-input"
              />
              <div className="absolute left-[-9999px] h-px w-px overflow-hidden" aria-hidden="true">
                <input name="website" tabIndex={-1} autoComplete="off" />
              </div>
              <button
                type="submit"
                data-testid="event-alert-submit"
                className="self-start rounded-full bg-plum px-7 py-4 font-extrabold text-gold transition-transform duration-200 hover:scale-[1.03] disabled:opacity-60"
              >
                Get ticket alerts
              </button>
              <Status msg={msg} okCls="text-[#1F3B47]" errCls="text-[#6B1E1E]" />
            </form>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
